export class ChartType {
  static readonly LINE = {type: 'line', stack: false, icon: 'fa fa-line-chart'};
  static readonly COLUMN = {type: 'column', stack: false, icon: 'fa fa-bar-chart'};
  static readonly BAR = {type: 'bar', stack: false, icon: 'fa fa-bar-chart'};
  static readonly PIE = {type: 'pie', stack: false, icon: 'fa fa-pie-chart'};
  static readonly AREA = {type: 'area', stack: false, icon: 'fa fa-area-chart'};
  static readonly STACKED_COLUMN = {type: 'column', stack: true, icon: 'fa fa-bar-chart'};
  static readonly STACKED_BAR = {type: 'bar', stack: true, icon: 'fa fa-bar-chart'};
  static readonly STACKED_AREA = {type: 'area', stack: true, icon: 'fa fa-area-chart'};
}
